/**
 * Prevent pinch-to-zoom on iOS Safari.
 *
 * iOS ignores `user-scalable=no` / `maximum-scale` in the viewport meta (since
 * iOS 10, for accessibility), so the viewport tag disables pinch-zoom on
 * Android but not on Safari. Safari instead emits the non-standard, WebKit-only
 * `gesture*` events for a pinch — preventing their default blocks the zoom.
 * Double-tap zoom is handled separately via CSS `touch-action: manipulation`.
 *
 * Listeners must be non-passive (`passive: false`) or `preventDefault()` is a
 * no-op. They live for the whole app lifetime, so no teardown is needed.
 */
export const disableMobileZoom = (): void => {
    const prevent = (e: Event): void => {
        e.preventDefault();
    };
    // `gesturestart` / `gesturechange` are not in the standard DOM event map,
    // so they resolve to addEventListener's generic `string` overload.
    document.addEventListener("gesturestart", prevent, {passive: false});
    document.addEventListener("gesturechange", prevent, {passive: false});
};
